import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg p-b-x20" }
const _hoisted_2 = { class: "cws" }
const _hoisted_3 = { class: "status-card-set" }
const _hoisted_4 = { class: "status-card-set__grid" }

import { PropType } from 'vue'
import { TravelInfoSettings, TravelInfoTerminal } from './../../types'
import ServiceTitleArea from './ServiceTitleArea.vue'
import TravelInfoPod from './TravelInfoPod.vue'
import TravelInfoMessages from './TravelInfoMessages.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TravelInfo',
  props: {
  settings: {
    type: Object as PropType<TravelInfoSettings>,
    required: true,
  },
  terminalData: {
    type: Object as PropType<TravelInfoTerminal>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ServiceTitleArea, {
            "title-info": __props.terminalData.titleInfo
          }, null, 8 /* PROPS */, ["title-info"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(TravelInfoPod, {
              "travel-info": __props.terminalData.terminalInfo.checkin
            }, null, 8 /* PROPS */, ["travel-info"]),
            _createVNode(TravelInfoPod, {
              "travel-info": __props.terminalData.terminalInfo.borderControls
            }, null, 8 /* PROPS */, ["travel-info"]),
            _createVNode(TravelInfoPod, {
              "travel-info": __props.terminalData.terminalInfo.departures
            }, null, 8 /* PROPS */, ["travel-info"])
          ])
        ])
      ])
    ]),
    _createVNode(TravelInfoMessages, {
      "travel-info-messages": __props.terminalData.travelInfo
    }, null, 8 /* PROPS */, ["travel-info-messages"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})